﻿<!-- 定义全局变量 -->
<script type="text/javascript">
// ******默认url链接********
//var urlBase="http://m-cs.jxjy.ahharc.com/api"; //168
	// var urlBase="http://192.168.1.132:8085";   //陈勇
    var urlBase="http://m-hnjx.ahharc.com/api";//线上
//  var urlBase="http://192.168.1.50:8081";   //陈勇
//     var urlBase="http://m-wjjxjy.ahharc.com/api";               //正式
//  var urlBase="http://weixin.ahsjxjy.com/api";          //微信测试
//     var urlBase="http://192.168.1.128:9091";

// ******图片链接********
var imgBase="https://www.ahsjxjy.com";

export default
{
  urlBase,
  imgBase
}
</script>



// WEBPACK FOOTER //
// global.vue?bea7047e